export default function toMoneyFormat({ amount, currency = 'USD' }) {
  const options   = {
    style:    'currency',
    currency: currency || 'USD'
  };
  const value     = amount;
  const formatted = new Intl.NumberFormat('en-US', options).format(value);
  return formatted;
}
